import React from "react";
import DOMPurify from "dompurify";
import FetchHelper from "./fetchHelper";
import DateUtility from "./dateUtility";
import { BPMemberRole } from "./bpMemberRole";
import { shiftIcons } from "./shiftIcons";
import { activateDialog } from "./dialogFocus";
/**
 * A compact look at one shift, over the page it was opened from.
 *
 * Deciding which of your own shifts to offer in a swap means knowing who else is on it and what is
 * showing - but leaving for /vagtinfo to find that out throws away everything picked so far, and on
 * a phone there is no second tab to keep the choice in. So this is the essentials only, fetched
 * when it is opened rather than loaded with the list: the list is thirty-odd shifts long and
 * carries nothing but the stamp for each.
 */
export default class ShiftPeek extends React.Component {
    constructor(props) {
        super(props);
        this.dialogRef = React.createRef();
        this.renderMember = (member, idx) => {
            const icon = member.role === BPMemberRole.operator ? "fas fa-film" : "fas fa-cash-register";
            return (React.createElement("li", { key: idx },
                React.createElement("span", { className: member.name ? "" : "yellow-shift" },
                    React.createElement("i", { className: icon, title: member.role }),
                    member.name || "Endnu ikke besat")));
        };
        this.renderBody = () => {
            const shift = this.state.shift;
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "mb-2" },
                    React.createElement("span", null,
                        shiftIcons(shift),
                        shift.date,
                        " kl. ",
                        shift.startTime,
                        "-",
                        shift.endTime)),
                React.createElement("h6", null, "Vagthold:"),
                React.createElement("ul", { className: "shift-peek-list" }, shift.members.map(this.renderMember)),
                React.createElement("h6", null, "Begivenheder:"),
                shift.events.length > 0
                    ? React.createElement("ul", { className: "shift-peek-list" }, shift.events.map((evt, idx) => (React.createElement("li", { key: idx },
                        "(",
                        evt.venue.venueName,
                        ") ",
                        DateUtility.parse(evt.startTime).toFormat("HH:mm"),
                        "\u00A0\u2022 ",
                        evt.eventContent.title))))
                    : React.createElement("p", { className: "text-muted" }, "Ingen begivenheder p\u00E5 vagten."),
                shift.notes
                    ? React.createElement(React.Fragment, null,
                        React.createElement("h6", null, "Noter til vagten:"),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(shift.notes) } }))
                    : null));
        };
        this.state = { isLoaded: false, shift: null, error: null };
    }
    componentDidMount() {
        // Escape closes it, Tab stays in it, and the focus goes back to what opened it.
        this.deactivate = activateDialog(() => this.dialogRef.current, () => this.props.onClose());
        FetchHelper.get(`/bpapi/shiftinfo/${this.props.shiftId}`)
            .then((result) => this.setState({ isLoaded: true, shift: result.shift }))
            .catch(() => this.setState({ isLoaded: true, error: "Vagten kunne ikke hentes" }));
    }
    componentWillUnmount() {
        var _a;
        (_a = this.deactivate) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    render() {
        return (React.createElement("div", { className: "shift-peek-backdrop", onClick: this.props.onClose },
            React.createElement("div", { className: "shift-peek", ref: this.dialogRef, tabIndex: -1, role: "dialog", "aria-modal": "true", "aria-label": "Om vagten", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "shift-peek-head" },
                    React.createElement("strong", null, "Om vagten"),
                    React.createElement("button", { type: "button", className: "btn-close", "aria-label": "Luk", onClick: this.props.onClose })),
                React.createElement("div", { className: "shift-peek-body" }, !this.state.isLoaded
                    ? React.createElement("div", { className: "bp-loading" },
                        React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" }))
                    : this.state.error
                        ? React.createElement("p", { className: "text-muted" }, this.state.error)
                        : this.renderBody()))));
    }
}
